import DynamicComponent from "./dynamicComponent"
import React from "react"

const AdjustableComponent = ({ blok, isRTDPage }) => {
	const { FullCSSControl, EasyClasses } = blok
	
	// Priority: FullCSSControl > EasyClasses > Default
	if (FullCSSControl) {
		return (
			<div className={FullCSSControl}>
				{blok.Block?.map(b => (
					<DynamicComponent blok={b} key={b._uid} isRTDPage={isRTDPage} />
				))}
			</div>
		)
	} else if (EasyClasses) {
		// Always apply both normalize-mobile-margins and custom classes
		// CSS handles breakpoints: < 1100px uses normalize, ≥ 1100px uses custom classes
		return (
			<div className={`${EasyClasses} normalize-mobile-margins`}>
				{blok.Block?.map(b => (
					<DynamicComponent blok={b} key={b._uid} isRTDPage={isRTDPage} />
				))}
			</div>
		)
	} else {
		// No classes specified, apply normalization for consistent spacing
		return (
			<div className="normalize-mobile-margins">
				{blok.Block?.map(b => (
					<DynamicComponent blok={b} key={b._uid} isRTDPage={isRTDPage} />
				))}
			</div>
		)
	}
}

export default AdjustableComponent
